import React from "react";
import { AppCheckbox, AppTableHeader, ParagraphText } from "../../../../Libraries";
import { Box } from "@mui/material";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const HeaderItem = ({ isOrderList, data, I18n }) => {
  const { handleSelection, orderToDownload, list } = data || {};

  return (
    <Box className={`invoiceListTableHeader ${styles.OrderTableHeader}`}>
      <Box className={`invListTableHeaderCol sevenColumn textLeft ${styles.OrderTableBox}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {isOrderList ? (
            <div className="checkboxCol">
              <AppCheckbox
                // disabled={true}
                checked={
                  Object.keys(orderToDownload).length == list.length &&
                  list.length != 0
                }
                label={<p className="marBot0 fontSize14"></p>}
                onClick={() => {
                  triggerLogEvent(analytics, "sc_orders_sort");
                  handleSelection("", list);
                }}
              />
            </div>
          ) : null}
          {isOrderList ? I18n.date : I18n.date_of_creation}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textLeft ${styles.OrderTableBox}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.order_no}.
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textLeft ${styles.OrderTableBox}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {isOrderList ? I18n.order_status : I18n.customer_tracking_id}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textLeft ${styles.OrderTableBox}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {isOrderList ? I18n.customer : I18n.return}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textLeft ${styles.OrderTableBox}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {isOrderList ? I18n.payment_method : I18n.order_status}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textRight ${styles.OrderTableBox}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {isOrderList ? I18n.total_amount : I18n.total_return_value}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textCenter ${styles.OrderTableBox}`} >
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {isOrderList ? I18n.actions : ""}
        </ParagraphText>
      </Box>

    </Box>
  );
};

export default HeaderItem;
